<template lang="pug">
v-container(fluid)
  cadastral-comparison-manager
</template>

<script>
import CadastralComparisonManager from '@/components/cadastral/CadastralComparisonManager';

export default {
  name: 'CadastralComparisonView',

  components: {
    CadastralComparisonManager,
  },

  data() {
    return {
    };
  },
};
</script>
